import api from "../core/client/AxiosConfig";

const requestApi = {
  getPetCover: (username: string, password: string, page: string) => {
    return api
      .post("api/pet-cover", { key: username, psw: password, page: page })
      .then((response) => response.data);
  },
};

export default requestApi;
